jQuery(($) => {
  function openInput($element) {
    $element.closest('.gfield').addClass('gfield--focused');
  }

  function maybeCloseInput($element) {
    if ($element.val() !== '') {
      $element.closest('.gfield').addClass('gfield--focused').removeAttr('style');
    } else {
      $element.closest('.gfield').removeClass('gfield--focused');
    }
  }

  if ($('.gfield')[0]) {
    $(document)
      .on('gform_post_render', function () {
        var $inputs = $(".gfield input[type='text']"),
          $emails = $(".gfield input[type='email']"),
          $phones = $(".gfield input[type='tel']"),
          $numbers = $(".gfield input[type='number']"),
          $urls = $(".gfield input[type='url']"),
          $checkboxes = $(".gfield input[type='checkbox']"),
          $radioButtons = $(".gfield input[type='radio']"),
          $textareas = $('.gfield textarea'),
          $selects = $('.gfield select');

        // If input or textarea has value, open it
        $inputs.each(function () {
          if ($(this).val() !== '') {
            openInput($(this));            
          }

          // If input has no placeholder, add single space to make the label not float
          if ($(this).attr('placeholder') === undefined) {
            $(this).attr('placeholder', ' ');
          }
        });

        $emails.each(function () {
          if ($(this).val() !== '') {
            openInput($(this));
          }

          // If input has no placeholder, add single space to make the label not float
          if ($(this).attr('placeholder') === undefined) {
            $(this).attr('placeholder', ' ');
          }
        });

        $phones.each(function () {
          if ($(this).val() !== '') {
            openInput($(this));
          }

          // If input has no placeholder, add single space to make the label not float
          if ($(this).attr('placeholder') === undefined) {
            $(this).attr('placeholder', ' ');
          }
        });

        $numbers.each(function () {
          if ($(this).val() !== '') {
            openInput($(this));
          }

          // If input has no placeholder, add single space to make the label not float
          if ($(this).attr('placeholder') === undefined) {
            $(this).attr('placeholder', ' ');
          }
        });

        $urls.each(function () {
          if ($(this).val() !== '') {
            openInput($(this));
          }

          // If input has no placeholder, add single space to make the label not float
          if ($(this).attr('placeholder') === undefined) {
            $(this).attr('placeholder', ' ');
          }
        });

        $checkboxes.each(function () {
          if ($(this).val() !== '') {
            openInput($(this));
          }
        });

        $radioButtons.each(function () {
          if ($(this).val() !== '') {
            openInput($(this));
          }
        });

        $textareas.each(function () {
          if ($(this).val() !== '') {
            openInput($(this));
          }
        });

        $selects.each(function () {
          if ($(this).val() !== '') {
            openInput($(this));
          }
        });

        // If input, textarea, or select focused, open it
        $inputs.focus(function () {
          openInput($(this));
        });

        $emails.focus(function () {
          openInput($(this));
        });

        $phones.focus(function () {
          openInput($(this));
        });

        $numbers.focus(function () {
          openInput($(this));
        });

        $urls.focus(function () {
          openInput($(this));
        });

        $checkboxes.focus(function () {
          openInput($(this));
        });

        $radioButtons.focus(function () {
          openInput($(this));
        });

        $textareas.focus(function () {
          openInput($(this));
        });

        $selects.focus(function () {
          openInput($(this));
        });

        // If input, textarea, or select blurred, close if has no value
        $inputs.blur(function () {
          maybeCloseInput($(this));
        });

        $emails.blur(function () {
          maybeCloseInput($(this));
        });

        $phones.blur(function () {
          maybeCloseInput($(this));
        });

        $numbers.blur(function () {
          maybeCloseInput($(this));
        });

        $urls.blur(function () {
          maybeCloseInput($(this));
        });

        $textareas.blur(function () {
          maybeCloseInput($(this));
        });

        $selects.blur(function () {
          maybeCloseInput($(this));
        });
      })
      .trigger('gform_post_render');
  }

  $('.gfield')
    .mouseenter(function () {
      $(this).addClass('gfield--hovered');
    })
    .mouseout(function () {
      $(this).removeClass('gfield--hovered');
    });

  $(document)
    .on('gform_post_render', function () {
      $('.m-gravity-form form .gform_page_footer .button').click(function () {
        var footer = $(this).parent(),
          form = footer.closest('form');

        if (!form.hasClass('loading')) {
          form.addClass('loading');
        }
      });

      $('.m-gravity-form form .gform_page_footer .a-button').click(function () {
        var footer = $(this).parent(),
          form = footer.closest('form');

        if (!form.hasClass('loading')) {
          form.addClass('loading');
        }
      });
    })
    .trigger('gform_post_render');
});
